import { useOrganiseList } from "context/OrganiseListContext";
import { useState, useEffect } from "react";
import useAuth from "./useAuth";

const useSubscriptionLogic = () => {
  const { user, loading: authLoading } = useAuth();
  const [showNotSubscribed, setShowNotSubscribed] = useState(false);
  const [isOpenListDialog, setIsOpenListDialog] = useState(false);
  const {
    organiseLists,
    createOrganiseList,
    loading,
    isFetchingOrganiseLogs,
    sharedWithLoading,
    isFetchingList,
  } = useOrganiseList();

  const handleOrganiseListAdd = async (list) => {
    try {
      await createOrganiseList(list);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (
      !loading &&
      !isFetchingList &&
      !isFetchingOrganiseLogs &&
      !sharedWithLoading &&
      organiseLists?.length === 0
    ) {
      const timer = setTimeout(() => {
        setShowNotSubscribed(true);
      }, 1000);

      return () => clearTimeout(timer);
    } else {
      setShowNotSubscribed(false);
    }
  }, [
    loading,
    isFetchingList,
    isFetchingOrganiseLogs,
    sharedWithLoading,
    organiseLists,
  ]);

  return {
    user,
    authLoading,
    showNotSubscribed,
    isOpenListDialog,
    setIsOpenListDialog,
    handleOrganiseListAdd,
  };
};

export default useSubscriptionLogic;
